import { createAsyncThunk } from '@reduxjs/toolkit'

import * as api from 'connections/restApi'

export const get = createAsyncThunk('activities/get', async () => {
  const response = await api.getActivities()
  return response
})
